import { message } from 'antd';

export const emptyShellMessage = () => {
  message.info('Пустышка');
};
